<template>
    <div id="login">
      <myhead></myhead>
      <div class="loginBox">
        <p class="title">Please login by your username</p> 
        <div class="name">
          Username: <input type="text" v-model="user.name">
        </div>
        <div class="pw">
          Password: <input type="text" v-model="user.pw">
        </div>
        <button @click="login" class="btn">Login</button>
      </div>

    </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import myhead from "./common/header.vue";
const url = require("../url").url 
export default {
  name: "Login",
  components: {
    myhead
  },
  data() {
    return {
      user: {
        name: "",
        pw: ""
      }
    };
  },
  methods: {
    login() {
      let self = this
      if (!this.user.name) {
        alert("Please input your username")
      }else if (!this.user.pw) {
        alert("Please input your password")
      }else{
        // console.log(this.user);
        let upData = qs.stringify(this.user)
        axios
          .post(url.login, upData)
          .then(function(res) {
            if (res.data.message === 'no user matched') {            
              alert("The user is not registered or the password is wrong")
            }else{            
              alert('Successful login')
              sessionStorage.setItem("user", res.data.data.name); 
              sessionStorage.setItem("cname", res.data.data.contact_name); 
              sessionStorage.setItem("cphone", res.data.data.contact_phone); 
              sessionStorage.setItem("email", res.data.data.email);               
              self.$router.push('/')
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }


    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../assets/css/style.less");

.loginBox{
  box-sizing: border-box;
  font-size: 14px;
  text-align: left;
  padding: 10px 20px;
  margin: 50px auto;
  width: 450px;
  height: 260px;
  border: 4px solid #dadada;
}
.title{
  font-weight: 600;
  border-bottom: 1px solid #dadada;
  height: 30px;
  line-height: 30px;
  margin-bottom: 25px;
}
.name,.pw{
  /* padding: 0 10% ; */
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.name>input,.pw>input{
  box-sizing: border-box;
  width: 248px;
  padding: 10px;
  border: 1px #d1ccc8 solid;
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
}
.btn{
  border: 0;
  color: #fff;
  background-color: @indexTheme;
  width: 248px;
  height: 30px;
  line-height: 30px;
  text-align:center;
  margin-left: 80px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue